 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		56: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"0ef6ecf94f66012edc9236b363260153d722ba48","2":"a9a7754c","3":"cb1608f2","4":"8d5b4a30445d2b887f5249c99b84e7cc3d3f556d","5":"4d37f247348525f4db8943ca843fb543965220c5","6":"382a42ad","10":"component---src-components-slides-blueprints-blueprint-blueprint-jsx","11":"component---src-components-slides-checkout-checkout-jsx","12":"component---src-components-slides-integrations-integration-integration-jsx","13":"component---src-components-slides-landing-pages-landing-page-landing-page-jsx","14":"component---src-components-slides-landing-pages-optin-page-optin-page-jsx","15":"component---src-components-slides-learn-page-page-jsx","16":"component---src-components-slides-partners-partner-partner-jsx","17":"component---src-pages-404-js","18":"component---src-pages-affiliate-terms-js","19":"component---src-pages-blueprints-js","20":"component---src-pages-case-studies-js","21":"component---src-pages-cookies-js","22":"component---src-pages-dpa-js","23":"component---src-pages-features-campaigns-js","24":"component---src-pages-features-js","25":"component---src-pages-features-people-js","26":"component---src-pages-features-personalization-js","27":"component---src-pages-features-portal-js","28":"component---src-pages-features-reporting-js","29":"component---src-pages-gdpr-js","30":"component---src-pages-index-js","31":"component---src-pages-integrations-js","32":"component---src-pages-learn-js","33":"component---src-pages-o-stealth-selling-4-js","34":"component---src-pages-o-stealth-selling-7-js","35":"component---src-pages-o-stealth-selling-js","36":"component---src-pages-old-case-studies-js","37":"component---src-pages-payment-update-js","38":"component---src-pages-podcasts-js","39":"component---src-pages-portal-launch-js","40":"component---src-pages-pricing-js","41":"component---src-pages-security-js","42":"component---src-pages-signup-25-off-special-js","43":"component---src-pages-signup-50-off-special-js","44":"component---src-pages-signup-details-js","45":"component---src-pages-signup-index-js","46":"component---src-pages-signup-portal-js","47":"component---src-pages-start-js","48":"component---src-pages-stealth-selling-js","49":"component---src-pages-subprocessors-js","50":"component---src-pages-success-js","51":"component---src-pages-thank-you-js","52":"component---src-pages-tos-js","53":"component---src-pages-upsell-stealth-selling-js","54":"component---src-pages-welcome-js"}[chunkId]||chunkId) + "-" + {"1":"64a8b3a272cbc90eef48","2":"0a8b65875f345cce8fa4","3":"828dcf3d272aba10c4e4","4":"28f0b5a815e8cf731424","5":"ab3721507eacb239c7e6","6":"7776dd60a1f41c6aa225","10":"1da2e06d5d685bf70434","11":"0758193ad6d34b1b567f","12":"8e85b968a8010700dbda","13":"071dc59f9132af8996c0","14":"69407b559d0cbfae10cc","15":"d89b91d8ad5d6a2f1fc5","16":"1dd08e2d144e414c6720","17":"f8b7da5aee8eb2f9389e","18":"324593735a231fde9966","19":"11c194e8544ab9bbc49f","20":"dbd6f10fe71b44c69ef8","21":"e33d7746c45652f7bf9c","22":"286e7d11f9889934e5d0","23":"06ad25fbe0158d072f23","24":"8542ee9e375e49390273","25":"751ffc58a8f00e7ed9ff","26":"f310d0bcd1cfb58d0150","27":"6206b731854bdc5fffa6","28":"7b37a6d9770f59a98338","29":"69a48bca1c7994b45a4b","30":"074304540fdf71405d8b","31":"a5e9a52681cf4f83e305","32":"8f54eb38c9b9fca19dd3","33":"2f23c5492a89f932cea4","34":"fe012328bed1ad8d3167","35":"efe17f60b31e4f4a85be","36":"0ff77ada773c94b978b1","37":"20a646622e282236f06f","38":"4bb4606e947f3f168766","39":"0ea9093621bcb11dd55c","40":"4385ef6d9a472df1b0b7","41":"9a74515d7db4596af68c","42":"651ecac567bd153adbc3","43":"c2c0817c0a5dc7dd9bc7","44":"b7d3dadb4c66a2d55b17","45":"c3ef65f71b72248021a2","46":"6c8a518e222186a5f933","47":"a08c469c1cb833e81443","48":"2d3f73a80c07794077f9","49":"63d67ffa2bb290c6b339","50":"2ce98b8ad91a570b42eb","51":"a0d6724ec0ba0368f392","52":"fb1ae50a72bcf3da418d","53":"125f5b4320cd47c20d15","54":"c20c657ddf04d3308521"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://www.dfstaging.com/gatsby-static/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
